module.exports = __webpack_public_path__ + "img/img_left_nav_bet.0bcd25d3.svg";